<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
<path d="M9.142 7.079 13.609 2H12.55L8.671 6.41 5.573 2H2l4.685 6.668L2 13.994h1.059l4.096-4.657 3.272 4.657H14L9.141 7.079Zm-1.45 1.648-.475-.664L3.44 2.779h1.626l3.048 4.264.475.664 3.962 5.543h-1.626L7.692 8.727Z"/>
</svg>

